<footer title="Informacion de la empresa"></footer>
